// tslint:disable
export enum PartyRoleRelationshipTypes {
    /**
     * @description Unknown
     */
    UNKN = 0,
    /**
     * @description Patient - Prescriber
     */
    PATPSRB = 1,
    /**
     * @description Patient - Primary Insurance Provider
     */
    PATPINS = 2,
    /**
     * @description Patient - Primary PBM
     */
    PATSPBM = 3,
    /**
     * @description Prescriber - Prescriber Site
     */
    PSRBSTE = 4,
    /**
     * @description Patient - Alternate Contact
     */
    PATALTCNT = 5,
    /**
     * @description Patient - Plan
     */
    PATPL = 6,
    /**
     * @description Prescriber - Plan
     */
    PSRBPL = 7,
    /**
     * @description Provider - Plan
     */
    PRVDPL = 8,
    /**
     * @description Payer - Plan
     */
    PAYPL = 9,
    /**
     * @description Payer - Alternate Contact
     */
    PAYCNT = 10,
    /**
     * @description Plan - Alternate Contact
     */
    PLCNT = 11,
    /**
     * @description Prescribersite - Contact
     */
    SITECNT = 12,
    /**
     * @description Pharmacy - Contact
     */
    PHARCNT = 13,
    /**
     * @description Foundation-Contact
     */
    FoundCnt = 14,
    /**
     * @description Service Provider - Service Agent
     */
    SrvPrvdSrvAgnt = 15,
    /**
     * @description Service Provider - Office Contact
     */
    SrvPrvdOffCnt = 16,
    /**
     * @description Practice – Prescriber Site
     */
    PracPsrbste = 17,
    /**
     * @description Prescriber Site – Prescriber
     */
    PsrbstePrac = 18,
}
(PartyRoleRelationshipTypes as any)['FOUNDCNT'] = 14;
(PartyRoleRelationshipTypes as any)['SRVPRVDSRVAGNT'] = 15;
(PartyRoleRelationshipTypes as any)['SRVPRVDOFFCNT'] = 16;
(PartyRoleRelationshipTypes as any)['PRACPSRBSTE'] = 17;
(PartyRoleRelationshipTypes as any)['PSRBSTEPRAC'] = 18;
